import { App } from '../../App'

export class CreateDefaultComponent {
  constructor(params) {
    this.params = params

    if (! App.isInitialized) {
      throw new Error('Application has not been initialized yet.')
    }
  }

  async setupDefaultComponent() {
    throw new Error("This method has to be overridden by a subclass.")
  }
}